module.exports = __webpack_public_path__ + "static/logo512-black-f853f7daefcd78e3ea3c010c8b27be62.png";